import register from "./register.js"
import placeholer from "./placeholer.js"

export default{
    ...register,
    ...placeholer
}